import React from 'react'
import app from "./firebase.js";
async function ResetPassword(email){
    var auth = app.auth();
   
    var status ;
    await auth.sendPasswordResetEmail(email).then(function() {
      // Email sent.
     
      status = {status:true};
    }).catch((error)=> {
      // An error happened.
     
      
      status =  {status:false,error:error};
    });
    return status;
}

export default  ResetPassword;